import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useUserState = <T>(initialValue: T): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const ref = useRef<T>(initialValue);
  const [state, setState] = useState<T>(initialValue);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  useEffect(() => {
    setState(ref.current);
  }, [isAuthenticated]);

  return [state, setState];
};

export default useUserState;
